import { render, staticRenderFns } from "./CoachAttendanceItem.vue?vue&type=template&id=31144fe4&scoped=true&"
import script from "./CoachAttendanceItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoachAttendanceItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CoachAttendanceItem.vue?vue&type=style&index=0&id=31144fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31144fe4",
  null
  
)

export default component.exports